export enum ConfigurationType{
    BOOK = 'BOOK',
    FIRM = 'FIRM',
    LOCATION = 'LOCATION',
    ORG_UNIT = 'ORG_UNIT',
    DEPARTMENT = 'DEPARTMENT',
}
